import { FC } from 'react';

import { DownloadOutlined } from '@ant-design/icons';
import { Button, theme, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { IExportUsersParams } from '@app/models/interfaces';
import { useLocalSelector } from '@app/services/hooks/useRedux';
import { useExportUsersQuery } from '@pages/Employees/hooks';

interface IProps {
  params: IExportUsersParams;
}

export const ExportButton: FC<IProps> = ({ params }) => {
  const { token } = theme.useToken();
  const employeesT = useTranslation(NSKeys.employees);
  const currentSession = useLocalSelector((state) => state.currentSession);

  const { mutate, status } = useExportUsersQuery();

  if (!currentSession.data?.scope?.$permissions?.export_users) {
    return null;
  }

  return (
    <Tooltip placement="bottomLeft" title={employeesT.t('exportTooltip')}>
      <Button
        icon={<DownloadOutlined style={{ color: token.colorPrimary }} />}
        loading={status === 'loading'}
        onClick={() => mutate(params)}
      />
    </Tooltip>
  );
};
